import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import ClientDetailsPage from "@/pages/ClientDetailsPage";
import StaffPage from "@/pages/StaffPage";
import AvailabilityPage from "@/pages/AvailabilityPage";
import Layout from "@/components/Layout";
import PublicProjectStatus from "@/pages/PublicProjectStatus";
import CalendarPage from "@/pages/CalendarPage";
import GroupfieManager from "@/pages/GroupfieManager";

function Protected({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="loading-spinner">
                <div className="text-sm text-gray-500 font-serif italic">Loading studio…</div>
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
    const { user } = useAuth();
    if (user === null) return null;
    if (user && user !== false) return <Navigate to="/" replace />;
    return children;
}

function App() {
    return (
        <AuthProvider>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route
                            path="/login"
                            element={
                                <PublicOnly>
                                    <LoginPage />
                                </PublicOnly>
                            }
                        />
                       
                        <Route
                            path="/"
                            element={
                                <Protected>
                                    <DashboardPage />
                                </Protected>
                            }
                        />
                        <Route
                            path="/clients/:id"
                            element={
                                <Protected>
                                    <ClientDetailsPage />
                                </Protected>
                            }
                        />
                        <Route
                            path="/staff"
                            element={
                                <Protected>
                                    <StaffPage />
                                </Protected>
                            }
                        />
                         <Route
                            path="/groupfie-manager"
                            element={
                                <Protected>
                                    <GroupfieManager />
                                </Protected>
                            }
                        />
                        <Route
                            path="/calendar"
                            element={
                                <Protected>
                                    <CalendarPage />
                                </Protected>
                            }
                        />
                        <Route
                            path="/availability"
                            element={
                                <Protected>
                                    <AvailabilityPage />
                                </Protected>
                            }
                        />
                        <Route path="/status/:id" element={<PublicProjectStatus />} />
                        <Route path="*" element={<Navigate to="/" replace />} />

                        

                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </div>
        </AuthProvider>
    );
}

export default App;
